import { render, staticRenderFns } from "./MCARegistry.vue?vue&type=template&id=30f03024&scoped=true"
import script from "./MCARegistry.vue?vue&type=script&lang=js"
export * from "./MCARegistry.vue?vue&type=script&lang=js"
import style0 from "./MCARegistry.vue?vue&type=style&index=0&id=30f03024&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f03024",
  null
  
)

export default component.exports